import apiClient from "./apiClient";
import { API_ROUTES } from "../config/baseURL";

export const getTiposIdentificacion = async () => {
  const res = await apiClient.get(API_ROUTES.tiposIdentificacion);
  return res.data;
};

export const getPaciente = async (unicId, tipoUnicId) => {
  const res = await apiClient.get(API_ROUTES.buscarPacienteApim(unicId, tipoUnicId));
  return res.data;
};

export const getPacienteExterno = async (unicId) => {
  const res = await apiClient.get(API_ROUTES.getPacienteExt(unicId));
  return res.data;
};

export const exportPacienteExterno = async (body) => {
  const res = await apiClient.post(API_ROUTES.exportPacienteExt, body);
  return res.data;
};

export const saveAnswer = async (body) => {
  const res = await apiClient.post(API_ROUTES.saveAnswers, body);
  return res.data;
};

export const saveFechaGestacion = async (body) => {
  const res = await apiClient.post(API_ROUTES.guardarFechaGestacion, body);
  return res.data;
};

export const getPacientesModal = async (filtro = "", filters = {}, signal) => {
  const params = new URLSearchParams();

  params.set("filtro", filtro);

  if (filters?.cohortSubgroupActive) {
    params.set("cohorte_subgrupo_activo", String(filters.cohortSubgroupActive));
  }

  const url = `${API_ROUTES.getPacientes}?${params.toString()}`;

  const res = await apiClient.get(url, signal ? { signal } : undefined);
  return res.data;
};

export const getLatestPatientResult = async (ident, tipoId, consecutivo) => {
  const res = await apiClient.get(
    API_ROUTES.getLatestPatientResult(ident, tipoId, consecutivo)
  );
  return res.data;
};

export const registrarBusquedaPaciente = async (body) => {
  const res = await apiClient.post(API_ROUTES.registrarBusquedaPaciente, body);
  return res.data;
};

export const getCumplimientoRutaMaterna = async (autoid) => {
  const res = await apiClient.get(API_ROUTES.getCumplimientoRutaMaterna(autoid));
  return res.data;
};
